import createDecorator from 'final-form-calculate';

import { inputFirstNameConfig, inputLastNameConfig } from '../../configs';

export const personGroupDecorator = createDecorator(
  {
    field: 'lastNameDisabled',
    updates: {
      [inputLastNameConfig.name]: () => undefined,
    },
  },
  {
    field: 'firstNameDisabled',
    updates: {
      [inputFirstNameConfig.name]: () => undefined,
    },
  },
);
